import React from 'react';
import {
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Checkbox,
  Col,
  Button
} from 'antd';
const FormItem = Form.Item;
const Option = Select.Option;

const CameraModalForm = Form.create()((props) => {
  const {
    title,
    camera,
    categories,
    visible,
    onCancel,
    onSubmit,
    form
  } = props;
  const {getFieldDecorator} = form;
  return (<Modal visible={visible} title={title} okText="Lưu" cancelText="Bỏ qua" onCancel={onCancel} onOk={onSubmit} footer={[
      <Button key="cancel" onClick={onCancel}>Bỏ qua</Button>,
      <Button key="submit" type="primary" ghost="ghost" onClick={onSubmit}>
        Lưu
      </Button>
    ]}>
    <Form layout="vertical">
      <FormItem >
        {getFieldDecorator('ID', {initialValue: camera.ID})(<span/>)}
      </FormItem>
      <FormItem label="Loại camera">
        {
          getFieldDecorator('CategoryID', {initialValue: camera.CategoryID.toString()})(<Select>
            {
              categories.map((cat) => {
                return <Option key={cat.ID} value={cat.ID.toString()}>{cat.Name}
                  - {cat.Series}</Option>
              })
            }
          </Select>)
        }
      </FormItem>
      <FormItem label="Tên camera">
        {
          getFieldDecorator('Name', {
            rules: [
              {
                required: true,
                message: 'Phải nhập tên camera!'
              }
            ],
            initialValue: camera.Name
          })(<Input/>)
        }
      </FormItem>
      <FormItem label="Địa chỉ IP">
        {
          getFieldDecorator('IP', {
            rules: [
              {
                required: true,
                message: 'Phải nhập địa chỉ IP!'
              }
            ],
            initialValue: camera.IP
          })(<Input/>)
        }
      </FormItem>
      <FormItem label="Stream Port">
        {
          getFieldDecorator('StreamPort', {
            rules: [
              {
                required: true,
                message: 'Phải nhập cổng Stream!'
              }
            ],
            initialValue: camera.StreamPort
          })(<InputNumber min={554} max={65535}/>)
        }
      </FormItem>
      <FormItem label="HTTP Port">
        {
          getFieldDecorator('HttpPort', {
            rules: [
              {
                required: true,
                message: 'Phải nhập cổng HTTP!'
              }
            ],
            initialValue: camera.HttpPort
          })(<InputNumber min={80} max={65535}/>)
        }
      </FormItem>
      <FormItem label="Channel No">
        {
          getFieldDecorator('ChannelNo', {
            rules: [
              {
                required: true,
                message: 'Phải nhập channel!'
              }
            ],
            initialValue: camera.ChannelNo
          })(<InputNumber min={0} max={65535}/>)
        }
      </FormItem>
      <FormItem label="Tài khoản">
        {
          getFieldDecorator('UserName', {
            rules: [
              {
                required: true,
                message: 'Phải nhập tài khoản!'
              }
            ],
            initialValue: camera.UserName
          })(<Input/>)
        }
      </FormItem>
      <FormItem label="Mật khẩu">
        {
          getFieldDecorator('Password', {
            rules: [
              {
                required: true,
                message: 'Phải nhập mật khẩu!'
              }
            ],
            initialValue: camera.Password
          })(<Input type="password" placeholder='••••••••••' autoComplete="new-password"/>)
        }
      </FormItem>
      <FormItem >
        <Col span={12}>
          <FormItem>
            {
              getFieldDecorator('IsMain', {
                initialValue: camera.IsMain,
                valuePropName: 'checked'
              })(<Checkbox>Main</Checkbox>)
            }
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem>
            {
              getFieldDecorator('Is3G', {
                initialValue: camera.Is3G,
                valuePropName: 'checked'
              })(<Checkbox>WAN</Checkbox>)
            }
          </FormItem>
        </Col>
      </FormItem>
    </Form>
  </Modal>);
})

export default CameraModalForm



// WEBPACK FOOTER //
// ./src/components/CameraModalForm.js